import seedrandom from 'seedrandom'

const commitSha = process.env.GATSBY_COMMIT_SHA

export const useStaticRandom = () => {
  return seedrandom(commitSha)
}
